import React, { Component } from 'react';
import ReactMapboxGl, { Control, ZoomControl, Marker, Popup, Cluster } from 'react-mapbox-gl';
import ItemPin from './ItemPin';

const TOKEN = 'pk.eyJ1IjoicGlhZnBhbXBoaWxlIiwiYSI6ImNrM3hrcTlscDB4cGEzbHBkMGp0NHdoYnMifQ.QlnFjai6_Y2oYc0_547Ghw'; // Set your mapbox token here

const openSearchButtonPath = 'M19.129,18.164l-4.518-4.52c1.152-1.373,1.852-3.143,1.852-5.077c0-4.361-3.535-7.896-7.896-7.896c-4.361,0-7.896,3.535-7.896,7.896s3.535,7.896,7.896,7.896c1.934,0,3.705-0.698,5.078-1.853l4.52,4.519c0.266,0.268,0.699,0.268,0.965,0C19.396,18.863,19.396,18.431,19.129,18.164z M8.567,15.028c-3.568,0-6.461-2.893-6.461-6.461s2.893-6.461,6.461-6.461c3.568,0,6.46,2.893,6.46,6.461S12.135,15.028,8.567,15.028z';
const clearSearchButtonPath = 'M10.185,1.417c-4.741,0-8.583,3.842-8.583,8.583c0,4.74,3.842,8.582,8.583,8.582S18.768,14.74,18.768,10C18.768,5.259,14.926,1.417,10.185,1.417 M10.185,17.68c-4.235,0-7.679-3.445-7.679-7.68c0-4.235,3.444-7.679,7.679-7.679S17.864,5.765,17.864,10C17.864,14.234,14.42,17.68,10.185,17.68 M10.824,10l2.842-2.844c0.178-0.176,0.178-0.46,0-0.637c-0.177-0.178-0.461-0.178-0.637,0l-2.844,2.841L7.341,6.52c-0.176-0.178-0.46-0.178-0.637,0c-0.178,0.176-0.178,0.461,0,0.637L9.546,10l-2.841,2.844c-0.178,0.176-0.178,0.461,0,0.637c0.178,0.178,0.459,0.178,0.637,0l2.844-2.841l2.844,2.841c0.178,0.178,0.459,0.178,0.637,0c0.178-0.176,0.178-0.461,0-0.637L10.824,10z';

const styles = {
    clusterMarker: {
        width: 30,
        height: 30,
        borderRadius: '50%',
        backgroundColor: '#51D5A0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
        border: '2px solid #56C498',
        cursor: 'pointer'
    },
    marker: {
        width: 30,
        height: 30,
        borderRadius: '50%',
        backgroundColor: '#E0E0E0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '2px solid #C9C9C9'
    }
};

const searchButtonOpenStyle = {
    position: 'absolute',
    top: '10px',
    left: '10px',
    background: '#FFFFFFAA',
    padding: '10px',
    display: 'inline-block',
    borderTopLeftRadius: '28px',
    borderTopRightRadius: '28px',
    borderTop: '1px solid rgba(0, 0, 0, 0.3)',
    borderLeft: '1px solid rgba(0, 0, 0, 0.3)',
    borderRight: '1px solid rgba(0, 0, 0, 0.3)',
    zIndex: '10'
};

const searchButtonClosedStyle = {
    position: 'absolute',
    top: '10px',
    left: '10px',
    background: '#FFFFFFAA',
    padding: '10px',
    display: 'inline-block',
    borderRadius: '28px',
    border: '1px solid rgba(0, 0, 0, 0.3)',
    zIndex: '10'
};

const searchResultsDivStyle = {
    left: '10px',
    background: '#FFFFFFAA',
    padding: '0 10px 10px',
    display: 'inline-block',
    borderBottomLeftRadius: '28px',
    borderBottomRightRadius: '28px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.3)',
    borderLeft: '1px solid rgba(0, 0, 0, 0.3)',
    borderRight: '1px solid rgba(0, 0, 0, 0.3)',
    zIndex: '10',
    position: 'absolute',
    top: '61px',
    width: '322px',
    maxHeight: 'calc(100% - 80px)',
    overflowY: 'auto'
};

const searchInputStyle = {
    background: '#FFFFFFAA',
    height: '30px',
    borderRadius: '15px',
    color: '#4C4C4C',
    border: '1px solid rgba(0, 0, 0, 0.3)',
    fontSize: '14px',
    outline: 'none'
};

const Map = ReactMapboxGl({
    accessToken: process.env.REACT_APP_MAP_TOKEN
});

export class SpoteeMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            zoom: [2],
            center: { lng: 0, lat: 0 },
            items: [],
            popupInfo: null,
            universeId: this.props.match.params.id,
            searching: false,
            suggestions: [],
            filter: ''
        };

        this.timeout = 0;
        this.onMapActionEnd = this.onMapActionEnd.bind(this);
    }

    componentDidMount() {
        this.getItems().then(result => this.setState({ items: result }));
    }

    clusterMarker = (coordinates, pointCount, getLeaves) => {
        return (
            <Marker
                key={coordinates.toString()}
                coordinates={coordinates}
                style={styles.clusterMarker}
                onClick={this.clusterClick.bind(this, coordinates, pointCount, getLeaves)}
            >
                <div>{pointCount}</div>
            </Marker>);
    };

    clusterClick = (coordinates, pointCount, getLeaves) => {
        var zoom = this.state.map.transform._zoom + 1;
        if (this.state.filter === '')
            this.setState({ popup: undefined, centered: false, searching: false });
        else
            this.setState({ popup: undefined, centered: false });
        this.state.map.flyTo({ center: coordinates, curve: 1, zoom: zoom, maxDuration: 1000, essential: true });
    };

    itemClick = (item) => {
        if (!this.state.centered || this.state.popup != item) {
            if (this.state.filter === '')
                this.setState({ popup: item, centered: true, searching: false });
            else
                this.setState({ popup: item, centered: true });
            this.state.map.flyTo({ center: item.geometry.coordinates, curve: 1, maxDuration: 1000, essential: true });
        }
    };

    mapMoveEnd = (map) => {
        if (Math.abs(this.state.map.transform._center.lng - this.state.center.lng) > .00001
            || Math.abs(this.state.map.transform._center.lat - this.state.center.lat) > .00001) {
            if (this.state.filter === '')
                this.setState({ zoom: [map.transform._zoom], center: map.transform._center, searching: false });
            else
                this.setState({ zoom: [map.transform._zoom], center: map.transform._center });
        }
    };

    onMapActionEnd = (map, event) => {
        if (this.state.popup || this.state.searching) {
            if (this.state.filter === '')
                this.setState({ popup: undefined, centered: false, searching: false });
            else
                this.setState({ popup: undefined, centered: false });
        }
    };

    renderPopup() {
        var popup = this.state.popup;

        return (
            popup && (
                <Popup
                    coordinates={[popup.geometry.coordinates[0], popup.geometry.coordinates[1]]}
                    offset={{
                        'bottom-left': [12, -38], 'bottom': [0, -38], 'bottom-right': [-12, -38]
                    }}>
                    <h1>{popup.properties.title}</h1>
                </Popup>
            )
        );
    }
    async getItems() {
        try {
            const response = await fetch(`item?universe=${this.state.universeId}`);
            const data = await response.json();
            return data;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    render() {
        var filter = this.state.filter;
        var filteredItems = this.state.items.filter(function (item) {
            return item.title.toLowerCase().includes(filter.toLowerCase());
        });
        var suggestions = this.state.filter !== '' ? filteredItems : [];
        var geojson = {
            type: "FeatureCollection",
            features: filteredItems.map(item => {
                return {
                    id: item.id,
                    type: "Feature",
                    properties: item,
                    geometry: {
                        type: "Point",
                        coordinates: [item.longitude, item.latitude]
                    }
                };
            })
        };

        var suggestions = this.state.filter !== '' ? geojson.features : [];
        var popup = this.renderPopup();
        var searchInputWidth = this.state.searching ? '300px' : '30px';
        var searchInputPadding = this.state.searching ? '0 10px 0 30px' : '0 0 0 30px';
        var searchCloseVisibility = this.state.searching ? 'visible' : 'collapse';
        var resultDivDisplay = this.state.searching ? 'block' : 'none';
        var searchButtonStyle = this.state.searching ? searchButtonOpenStyle : searchButtonClosedStyle;
        var openSearchButtonColor = this.state.searching ? 'rgb(76, 76, 76)' : 'rgba(0, 0, 0, 0.3)';
        var clearSearchButtonColor = this.state.filter !== '' ? 'rgb(76, 76, 76)' : 'rgba(0, 0, 0, 0.3)';

        var suggestionContent = null;
        if (suggestions.length === 0) {
            suggestionContent = (<span style={{ margin: '0 10px', fontStyle: 'italic' }}>Aucun résultat</span>);
        } else {
            suggestionContent = (<ul className='react-autosuggest__suggestions-list'>
                {suggestions.map((item, key) => (
                    <li className='react-autosuggest__suggestion' data-item={item.properties} key={item.properties.id} onClick={this.itemClick.bind(this, item)} >
                        <span>{item.properties.title}</span>
                    </li>
                ))}
            </ul>);
        }

        return (
            <>
                <Map
                    center={this.state.center}
                    zoom={this.state.zoom}
                    style="mapbox://styles/mapbox/outdoors-v9"
                    containerStyle={{
                        height: '100%',
                        width: '100%'
                    }}
                    onMoveEnd={this.mapMoveEnd}
                    onClick={this.onMapActionEnd}
                    onDblClick={this.onMapActionEnd}
                    onDragEnd={this.onMapActionEnd}
                    onTouchEnd={this.onMapActionEnd}
                    onStyleLoad={map => this.setState({ map: map })}>
                    <Cluster ClusterMarkerFactory={this.clusterMarker}>
                        {geojson.features.map((feature, key) => (
                            <Marker key={key} coordinates={feature.geometry.coordinates} data-feature={feature}>
                                <ItemPin size={24} onClick={this.itemClick.bind(this, feature)} rate={feature.properties.score} />
                            </Marker>
                        ))}
                    </Cluster>

                    {popup}

                    <ZoomControl />

                    <div
                        style={searchButtonStyle}>
                        <input type='text'
                            ref={(input) => { this.searchInput = input; }}
                            value={filter}
                            onChange={(e) => { this.setState({ filter: e.target.value, popup: undefined, centered: false }) }}
                            style={{
                                ...searchInputStyle,
                                width: searchInputWidth,
                                padding: searchInputPadding
                            }} />
                        <svg width='30' height='30' viewBox='0 0 30 30'
                            onClick={() => {
                                if (!this.state.searching) {
                                    this.setState({ popup: undefined, centered: false, searching: true });
                                    this.searchInput.focus();
                                }
                            }}
                            style={{
                                position: 'absolute',
                                left: '15px',
                                top: '15px'
                            }}>
                            <path fill={openSearchButtonColor} d={openSearchButtonPath}></path>
                        </svg>
                        <svg width='30' height='30' viewBox='0 0 30 30'
                            onClick={() => {
                                if (this.state.searching) {
                                    this.setState({ popup: undefined, centered: false, filter: '', suggestions: [] });
                                    this.searchInput.focus();
                                }
                            }}
                            style={{
                                position: 'absolute',
                                right: '5px',
                                top: '15px',
                                visibility: searchCloseVisibility
                            }}>
                            <path fill={clearSearchButtonColor} d={clearSearchButtonPath}></path>
                        </svg>
                    </div>
                    <div
                        style={{
                            ...searchResultsDivStyle,
                            display: resultDivDisplay
                        }}>
                        {suggestionContent}
                    </div>
                </Map>
            </>
        );
    }
}